import React, { Component } from 'react';
import Notificacao from '../../components/Notificacao';
import { getLoggedInUser } from "../../helpers/authUtils";
import IconAdd from '../../assets/svg/add-plus.svg';
import PreLoaderWidget from '../../components/Loader';
import { FilaProcedimentoEnum, PermissaoGeral } from '../../helpers/enums';
import IconCalendar from '../../assets/svg/ic-actions-calendar.svg';
import IconTime from '../../assets/svg/ic-contact-time.svg';
import moment from 'moment';
import LoadingFullScreen from '../../components/LoadingFullScreen';
import { onlyNumbers, sendWhatsappButtons, sendWhatsappMessage } from '../../helpers/utils';
import InputIcon from '../../gb-components/InputIcon';
import { saveLogFila } from '../../Libs/filaProcedimentos';

export default class DataFila extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: getLoggedInUser(),
            notifition: false,
            loading: false,
            saving: false,
            data: "",
            hora: "",
        };
    }

    async componentDidMount() {
        this.setState({ loading: true })

        console.log(this.props)
        const item = this.props.item
        this.setState({
            date: item.data_agendamento,
            hour: item.hora_agendamento,
        })

        this.setState({ loading: false })
    }


    _setCadastro = async () => {
        this.setState({ saving: true });

        const {
            date,
            hour
        } = this.state;

        if (!date) {
            this.setState({
                notifition: true,
                msg: "Informe uma data",
                nameclass: 'alert-danger',
                loading: false
            });
            return;
        }

        if (!hour) {
            this.setState({
                notifition: true,
                msg: "Informe um horário",
                nameclass: 'alert-danger',
                loading: false
            });
            return;
        }


        const item = this.props.item
        try {
            await item.ref.update({
                status: FilaProcedimentoEnum.ProcedimentoAgendado,
                data_agendamento: date,
                hora_agendamento: hour,
                updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
                user_set_date: this.state.user.ref,
                user_update: this.state.user.ref,
            })
            // ISSO É FEITO PARA QUE A VARIAVEL ITEM TAMBÉM NÃO SEJA ALTERADA
            let data = { ...item }
            delete data.ref
            delete data.id
            await saveLogFila(item.id, data)

            const phone = item.paciente.paciente.whatsapp ? item.paciente.paciente.whatsapp : `55${onlyNumbers(item.paciente.paciente.telefones)}`
            const formatedDate = moment(date).format('DD/MM/YYYY')


            try {
                if (item.fora_municipio) {
                    await sendWhatsappMessage(
                        phone,
                        `Seu procedimento: ${item.procedimento.descricao} foi agendado para o dia ${formatedDate} às ${hour} horas.`
                    )
                } else {
                    const wpMessage = await sendWhatsappButtons(
                        phone,
                        `Seu procedimento: ${item.procedimento.descricao} foi agendado para o dia ${formatedDate} às ${hour} horas.\nO não comparecimento sem justificativa enviará sua solicitação para o final da fila.\n\nVocê confirma que comparecerá na data marcada?`,
                        [
                            {
                                "id": "fila-sim",
                                "label": "SIM"
                            },
                            {
                                "id": "fila-nao",
                                "label": "NÃO"
                            },
                        ]
                    )
                    await item.ref.update({ "confirm_wp_message_id": wpMessage.data.messageId })
                }
            } catch (error) {
                console.log(error)
            }

            this.setState({ saving: false })
            if (this.props.closeModal) {
                this.props.closeModal();
            }
        } catch (error) {
            console.log(error)
            this.setState({
                notifition: true,
                msg: "Algo deu errado, tente novamente ou entre em contato conosco",
                nameclass: 'alert-danger',
                saving: false
            });
        }
    };

    render() {
        if (getLoggedInUser().permissao.toString() !== PermissaoGeral.Paciente) {
            return (
                <React.Fragment>
                    {this.state.saving && <LoadingFullScreen></LoadingFullScreen>}

                    {this.state.loading ? (<div className="text-center"><PreLoaderWidget /> aguarde...</div>) : (

                        <div className="gb-form">

                            <div className="title">
                                {!this.props.data_agendamento ? (
                                    <>
                                        <img src={IconAdd} /> Informar Data do Procedimento
                                    </>
                                ) : (
                                    <>
                                        Editar Data Procedimento
                                    </>
                                )}
                            </div>

                            {this.state.notifition ? (
                                <div className="pl-2 pr-2 m-1">
                                    <Notificacao
                                        msg={this.state.msg}
                                        nameclass={this.state.nameclass}
                                    />
                                </div>
                            ) : null}

                            <div className="row">
                                <div className="col-md-6">
                                    <InputIcon
                                        placeholder="Data da Procedimento"
                                        type="date"
                                        id="dataAgendamento"
                                        value={this.state.date}
                                        onChange={text => {
                                            this.setState({ date: text })
                                        }}
                                        style={{ width: '100%' }}
                                        icon={IconCalendar}
                                    />
                                </div>
                                <div className="col-md-5 offset-md-1">
                                    <InputIcon
                                        placeholder="Data da Procedimento"
                                        type="time"
                                        id="horaAgendamento"
                                        value={this.state.hour}
                                        onChange={text => {
                                            this.setState({ hour: text })
                                        }}
                                        style={{ width: '100%' }}
                                        icon={IconTime}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <button onClick={() => this._setCadastro()} className="btn gb-button to-form full mt-3">
                                        Salvar e notificar paciente
                                    </button>
                                </div>
                            </div>

                        </div>
                    )}
                </React.Fragment>
            );
        } else {
            return (<div className="alert alert-danger text-center">VOCÊ NÃO TEM PERMISSÃO DE ACESSO NESTA PÁGINA</div>)
        }
    }
}
